<script setup>
import { useI18n } from "vue-i18n";
import getLocale from "@/locale";
const { t } = useI18n();
const locale = getLocale()
</script>

<template>
  <div class="footer-wrapper">
    <div class="footer-container">
      <div class="footer-logo">
        <img src="../assets/logo/just-eat-logo.svg" alt="logo" />
      </div>
      <div class="footer-links">
        <a :href="t('termsAndConditions.footer.signUpRestaurantLink')" target="_blank">{{t("termsAndConditions.footer.signUpRestaurant")}}</a>
        <a :href="t('termsAndConditions.footer.aboutUsLink')" target="_blank">{{t("termsAndConditions.footer.aboutUs")}}</a>
        <a :href="t('termsAndConditions.footer.careersLink')" target="_blank">{{t("termsAndConditions.footer.careers")}}</a>
        <a :href="t('termsAndConditions.footer.deliverLink')" target="_blank">{{t("termsAndConditions.footer.deliver")}}</a>
        <a  v-if="locale === 'en'" :href="t('termsAndConditions.footer.jetForBusinessLink')" target="_blank">{{t("termsAndConditions.footer.jetForBusiness")}}</a>
        <a  v-else-if="locale === 'ie'" :href="t('termsAndConditions.footer.jetGiftCardsLink')" target="_blank">{{t("termsAndConditions.footer.jetGiftCards")}}</a>
        <a :href="t('termsAndConditions.footer.privacyPolicyLink')" target="_blank">{{t("termsAndConditions.footer.privacyPolicy")}}</a>
        <a :href="t('termsAndConditions.footer.termsAndConditionsLink')" target="_blank">{{t("termsAndConditions.footer.termsAndConditions")}}</a>
        <a :href="t('termsAndConditions.footer.cookiePolicyLink')" target="_blank">{{t("termsAndConditions.footer.cookiePolicy")}}</a>
      </div>
      <p>© 2025 Just Eat Takeaway.com</p>
    </div>
  </div>
</template>

<style scoped>
p {
  color: white;
  font-size: 13px;
  line-height: 18px;
}

.footer-wrapper {
  background-color: #FF8000;
  width: 100%;
  overflow: auto;
}

.footer-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 20px;
}

.footer-logo {
  max-width: 161px;
  max-height: 56px;
}

.footer-logo img {
  padding-top: 10px;
  width: 100%;
  height: auto;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 25px 20px 0;
  justify-content: center;
}

.footer-links a {
  font-family: "JETSansVF2", sans-serif;
  font-size: 14px;
  color: #fff;
  text-decoration: none;
  line-height: 19px;
}

@media (max-width: 768px) {
  .footer-container {
    align-items: center;
    justify-content: flex-start;
    padding-top: 40px;
  }

  .footer-logo {
    display: none;
  }

  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 0;
  }
}
</style>